export default __webpack_public_path__ + "static/media/mashkour-pic.cb35b460.jpeg";